export enum MomentoScore {
    Unknown = 0,
    Red = 1,
    Orange = 2,
    Green = 3,
}